import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {
  accountId: string;
};

export type PlaidLinkTokenResponse = {
  link_token: string;
};

type Data = PlaidLinkTokenResponse;

export const createPlaidLinkToken = async (variables: Variables): Promise<Data> => {
  const result = await axiosConsumerAppInstance.post<Data, AxiosResponse<Data>>(
    `/plaid/link-token/${variables.accountId}`
  );
  return result.data;
};

export const useCreatePlaidLinkToken = (
  options?: BaseMutationOptions<Data, Variables>
): BaseUseMutationResult<Data, Variables> => {
  return useBaseMutation(createPlaidLinkToken, {...options});
};
